import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Zoom } from "react-reveal";
import { useQuery } from "react-query";
import HeaderInner from "../../Components/HeaderInner";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { useBusinessNameContext } from "../../context/BusinessName";
import { getInStayRentalCategoriesAPI } from "../../API/InStayRentalAPI";
import { getImageUrl } from "../../utils/media";

function InStayRentalCategories() {
  const { businessName } = useBusinessNameContext();

  const location = useLocation();
  const navigate = useNavigate();

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  const lang = sessionStorage.getItem("lang");

  const { data, isLoading, error } = useQuery(
    ["in-stay-rental-categories", room_uuid, lang],
    () => getInStayRentalCategoriesAPI({ room_uuid, lang })
  );

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  if (error) {
    if (error?.response?.status === 404) {
      navigate(`/not-found`);
      return null;
    }
    return <div>Error fetching data</div>;
  }

  const responseData = data?.data?.data;

  if (!isLoading && data?.data?.status === false) {
    navigate(`/${room_uuid}/qr-scan`);
    return null;
  }

  const categories = responseData?.categories || [];
  const headerTitle = (
    responseData?.center_header ||
    responseData?.title ||
    "In Stay Rental"
  ).replace("In Stay", "In-Stay");

  if (!isLoading && categories.length === 1) {
    navigate(
      `/${room_uuid}/in-stay-rental/category/${categories[0].id}/items`,
      { replace: true }
    );
    return null;
  }

  return (
    <>
      <HeaderInner headerName={headerTitle} />

      <main className="home-main bg-white pt-3">
        <div>
          {isLoading ? (
            <CustomBusinessServiceLoader
              businessName={businessName}
              loader={"carRental"}
            />
          ) : categories.length > 0 ? (
            categories.map((category) => (
              <div id={category.name} key={category.id}>
                <Zoom>
                  <div
                    className="con-img-container v3"
                    onClick={() =>
                      navigate(
                        `/${room_uuid}/in-stay-rental/category/${category.id}/items`
                      )
                    }
                  >
                    <div className="con-img">
                      {category.image && (
                        <img
                          src={getImageUrl(category.image)}
                          alt={category.name}
                        />
                      )}
                      <p></p>
                    </div>
                  </div>

                  <div className="con-text-container">
                    <p>{category.name}</p>
                    <hr className="mb-0 dark" />
                  </div>
                </Zoom>
              </div>
            ))
          ) : null}
        </div>
      </main>
    </>
  );
}

export default InStayRentalCategories;
